const toHex = (bytes: Uint8Array): string => Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');

// Returns the lowercase hex SHA-256 of the UTF-8 bytes of the input.
// Apple gets this hash. The server gets the raw value and hashes it again.
export const sha256Hex = async (input: string): Promise<string> => {
  const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
  return toHex(new Uint8Array(digest));
};

// Returns a random hex string for the OAuth `state` value.
// It is synchronous, so it can run inside a click handler before a popup opens.
export const randomState = (byteLength = 16): string => {
  const bytes = new Uint8Array(byteLength);
  globalThis.crypto.getRandomValues(bytes);
  return toHex(bytes);
};
